<script module lang="ts">
  import type { DisplayConfig } from '#entities/lib/entity_links'
  import type { PropertyCategory } from '#server/controllers/entities/lib/properties/properties'
  import type { InvClaimValue } from '#server/types/entity'
  import { properties } from '../../lib/editor/properties_per_type'

  export type CategoryAvailableExternalId = DisplayConfig & { value: InvClaimValue, linkNum: number }
  export type AvailableExternalIdsByCategory = Record<PropertyCategory, CategoryAvailableExternalId[]>
</script>

<script lang="ts">
  import { keys, pick, values } from 'lodash-es'
  import { objectEntries } from '#app/lib/utils'
  import CategoryExternalIds from '#entities/components/layouts/category_external_ids.svelte'
  import { externalIdsDisplayConfigs } from '#entities/lib/entity_links'
  import type { Claims } from '#server/types/entity'

  const {
    claims,
  }: {
    claims: Claims
  } = $props()

  const availableExternalIds = $derived(pick(externalIdsDisplayConfigs, keys(claims)))
  const availableExternalIdsByCategory = $derived.by(() => {
    const _availableExternalIdsByCategory = {}
    let linkNum = 0
    for (const propertyData of values(availableExternalIds)) {
      const { property } = propertyData
      const { category } = properties[property]
      _availableExternalIdsByCategory[category] = _availableExternalIdsByCategory[category] || []
      for (const value of claims[property]) {
        _availableExternalIdsByCategory[category].push({ ...propertyData, value, linkNum: linkNum++ })
      }
    }
    return _availableExternalIdsByCategory as AvailableExternalIdsByCategory
  })
</script>

<div class="entity-claims-links">
  {#each objectEntries(availableExternalIdsByCategory) as [ category, categoryAvailableExternalIds ] (category)}
    <CategoryExternalIds {category} {categoryAvailableExternalIds} />
  {/each}
</div>
